import type { ThemeCodeStyle } from './types';

export function formateThemeData(themeList: Required<Required<any>['retdata']>['list']) {
  const theme = {} as ThemeCodeStyle;
  themeList.forEach((element) => {
    const paramEntries = element.paramList?.map((p) => [p.code.trim(), p.value]);

    // const params = Object.fromEntries(paramEntries || []);  //Object.fromEntries不兼容低版本机型
    const params: any = {};
    paramEntries.forEach((item) => {
      params[item[0]] = item[1];
    });
    if (element.componentCode) {
      theme[element.componentCode] = params;
    }
  });
  return theme;
}

export function hex2RgbColor(hexColor: string, opacity?: string | number) {
  let normalHex = hexColor.replace('#', '');
  if (normalHex.length === 3) {
    normalHex = `${normalHex[0]}${normalHex[0]}${normalHex[1]}${normalHex[1]}${normalHex[2]}${normalHex[2]}`;
  }
  if (normalHex.length !== 6) {
    console.error(new Error(`Color: ${hexColor} is invalid value`));
    return '';
  }
  const rgbaString = `${Number('0x' + normalHex[0] + normalHex[1])},${Number(
    '0x' + normalHex[2] + normalHex[3]
  )},${Number('0x' + normalHex[4] + normalHex[5])}`;
  if (opacity !== undefined) {
    return `rgba(${rgbaString},${opacity})`;
  }
  return `rgb(${rgbaString})`;
}

//  转变为渐变颜色
export function colorTolinear(color: string, deg: number) {
  return `${color} linear-gradient(${deg}deg,rgba(255,255,255,0.4) 0%,rgba(255,255,255,0) 100%)`;
}
